import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'

const menuEditorSearchSchema = z.object({}).optional()

export const Route = createFileRoute('/_authenticated/menu-editor/')({
  validateSearch: menuEditorSearchSchema,
})

